import { Box } from '@mui/material'
import CrossTalkDetailComponent from 'components/CrossTalk/Detail'
import Top from 'components/Fellow/Top'
import { Helmet } from 'react-helmet-async'

export default function CrossTalk() {
  return (
    <Box className="pb-10">
      <Helmet>
        <title>フォーシーズンズ | インタビュー</title>
      </Helmet>
      <Top />
      <CrossTalkDetailComponent />
    </Box>
  )
}
